// Vue
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import { Icon } from '../../../icon/Icon'
import { HeaderOverlay } from '../../overlay/HeaderOverlay'
import { Col } from '../../../col/Col'
import { Container } from '../../../container/Container'
import { Row } from '../../../row/Row'
import { Link } from '../../../link/Link'
import { H } from '../../../h/H'

// Interfaces
import {ILanguage} from '../../../../../interfaces/ILanguage'

// Enums
import { Language } from '../../../../../enums/Language'

@Component({
    mixins: [
        template,
    ],
    components: {
        Icon,
        HeaderOverlay,
        Col,
        Container,
        Row,
        Link,
        H
    }
})
export class Languages extends Vue {

    @Prop()
    public activeOverlayInternal!: string

    @Prop()
    public languages!: ILanguage[]

    @Prop()
    public currentLanguage!: Language

    private handleOpen(){
        this.$emit('open')
    }

    private handleClose() {
        this.$emit('close')
    }

    public handleLanguageSelect(language: Language) {
        this.$emit('change-language', language)
    }

    public get currentLanguageName() {
        if (this.currentLanguage && this.languages && this.languages.length > 0) {
            let lang = this.languages.find(l => l.code == this.currentLanguage);
            if (lang) {
                return lang.name;
            }
        }

        return this.$t('SPRACHE');
    }
}